import { memo } from "react";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { MarketplaceExtraData } from "../../../types";
import { ChipToggle, SectionCard } from "../primitives";
import { WARRANTY_OPTIONS } from "services/api/sales/listings/consts";

interface Props {
  values: MarketplaceExtraData;
  onChange: (patch: Partial<MarketplaceExtraData>) => void;
}

const WarrantySection: React.FC<Props> = ({ values, onChange }) => {
  const handleDropdown = (_e: any, name: string, item: { value: string }) =>
    onChange({ [name]: item.value } as Partial<MarketplaceExtraData>);

  const toggle = (name: "extendedWarranty" | "g1ClubWarranty") =>
    onChange({ [name]: !values[name] } as Partial<MarketplaceExtraData>);

  return (
    <SectionCard title="Jamstvo">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <div>
          <Dropdown
            name="warrantyCode"
            label="Jamstvo"
            value={values.warrantyCode}
            options={WARRANTY_OPTIONS}
            onChange={handleDropdown}
          />
        </div>

        {/* `pt-8` poravnava čip s poljem dropdowna, a ne s labelom iznad njega. */}
        <div className="flex items-center sm:pt-8">
          <ChipToggle
            label="Produljeno jamstvo"
            selected={values.extendedWarranty}
            onToggle={() => toggle("extendedWarranty")}
          />
        </div>

        <div className="flex items-center sm:pt-8">
          <ChipToggle
            label="G1 klub jamstvo"
            selected={values.g1ClubWarranty}
            onToggle={() => toggle("g1ClubWarranty")}
          />
        </div>
      </div>
    </SectionCard>
  );
};

export default memo(WarrantySection);
